import { buildStateEvent, GenericStateEvent } from '../../common-redux'
import { RoleState } from './model'

export interface SavePermissionAndScopeStateEvent<T> extends GenericStateEvent<T> {}

export const SavePermissionAndScopeListEvent = {
    type: 'SavePermissionAndScopeListEvent',
    build: (payload: RoleState) => buildStateEvent(SavePermissionAndScopeListEvent.type, payload)
}
